// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3n-Fe","inputDescription":"styles_inputDescription__UjTKq"};